// App
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Tracking

// Misc / utils
import IconArrowGrey from 'images/icons/arrow-dark-grey-down.min.svg';
import * as S from './styles';
import { emitTrackSortListingsEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';

const SortButton = () => {
  // Redux
  const orderByState = useSelector((state: RootReduxState) => state.filter.orderBy);

  // Hooks
  const { filterChange } = useFilterChange();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const option = e.target.value;
    const selectedOrderBy = { orderBy: option };

    filterChange(selectedOrderBy);

    emitTrackSortListingsEvent({
      triggerLocation: 'search_results',
      triggerObject: 'search_results|header',
    });
  };

  return (
    <>
      <S.SelectButton value={orderByState} onChange={handleChange}>
        <option value="">Sort: Recommended</option>
        <option value="activated">Sort: Newest</option>
        <option value="weekViews">Sort: Most popular</option>
        <option value="highPrice">Sort: High price</option>
        <option value="lowPrice">Sort: Low price</option>
      </S.SelectButton>
      <S.SelectButtonArrow src={IconArrowGrey} height="12px" width="12px" alt="" />
    </>
  );
};

export default SortButton;
